<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3">                 
                    
                    <div class="row pb-2">
                      <div class="col-4 input-group offset-1">
                          <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                              </div>
                              <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                            </div>
                        </div>
                      <div class="col-4 input-group">
                          <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                              </div>
                              <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                            </div>
                      </div>
                      <div class="3">
                          <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                          <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                        </div>
                      </div>
      
                    <!-- Tabele row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">
                      <div class="row justify-content-center">
                        <div class="col-12 text-center">
                          <h4>{{companyName}}</h4>
                          <h6>Profit And Loss Statement</h6>                     
                        </div>
                    </div>

                      <div class="col-8 table-responsive offset-2 pt-4 table-borderless" id="pnlReport">
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">             
                          <tbody>
                          <tr>    
                            <td> Sales Income</td> 
                            <td class="text-right">{{salesIncome |  number:'1.2-2'}}</td>                                                                                
                          </tr>  
                          <tr class="border_bottom">    
                            <td>Cost of Sales</td> 
                            <td class="text-right">{{costOfSales |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td class="text-bold">Gross Profit</td> 
                            <td class="text-right text-bold">{{grossProfit |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td class="text-bold">(-) Expenses</td>                                                                                                         
                          </tr> 
                          <tr>    
                            <td>Administration</td> 
                            <td class="text-right">{{adminExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td>Repair and Maintenance</td> 
                            <td class="text-right">{{distributionExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td>Outside Vehicle Rent</td> 
                            <td class="text-right">{{marketingExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td>Salary</td> 
                            <td class="text-right">{{salaryExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td>Finance</td> 
                            <td class="text-right">{{financeExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr class="border_bottom">    
                            <td>Other</td> 
                            <td class="text-right">{{otherExp |  number:'1.2-2'}}</td>                                                                                
                          </tr> 
                          <tr>    
                            <td class="text-bold">Total Expense</td> 
                            <td class="text-right text-bold">({{totalExp  |  number:'1.2-2'}})</td>                                                                                
                          </tr> 
                          <tr>    
                            <td class="text-bold">Net Profit</td> 
                            <td class="text-right text-bold">{{netProfit |  number:'1.2-2'}}</td>                                                                                
                          </tr>                                             
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button"   class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button> 
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                      </div>
                    </div>

                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->         
 </body>







